import configDev from "../../../../../assets/js/config.json";

const configProdUrl = "/assets/js/config.json";

let baseURL: string;
let financasBaseUrl: string;
let indicadoresUrl: string;

async function loadConfig(): Promise<any> {
  if (window.location.href.includes("localhost")) {
    //verificar se tem necessidade de uma validação melhor de ambiente
    return configDev;
  } else {
    const response = await fetch(configProdUrl);
    if (!response.ok) {
      throw new Error(`Erro ao buscar as basesUrl's de produção`);
    }

    return response.json();
  }
}

export async function initializeBaseUrls() {
  const config = await loadConfig();

  baseURL = config.HORIZON_URL || import.meta.env.VITE_APP_HORIZON_URL;
  financasBaseUrl =
    config.FINANCAS_URL || import.meta.env.VITE_APP_FINANCAS_URL;
  indicadoresUrl =
    config.INDICADORES_URL || import.meta.env.VITE_APP_HORIZON_URL;
}

export { baseURL, financasBaseUrl, indicadoresUrl };
